import Download from "../components/Download";
import Footer from "../components/Footer";
import Franchises from "../components/Franchises";
import Genre from "../components/Genre";
import Header from "../components/Header";
import HeroBanner from "../components/HeroBanner";
import Sponcers from "../components/Sponcers";
import Trending from "../components/Trending";
import Watch from "../components/Watch";

const Homepage = () => {
  return (
    <div>
      <div>
        <div>
          <Header />
        </div>
        <div>
          <HeroBanner />
        </div>
        <div>
          <Franchises />
        </div>
        <div>
          <Watch />
        </div>
        <div>
          <Download />
        </div>
        <div>
          <Genre />
        </div>
        <div>
          <Trending />
        </div>
        <div>
          <Sponcers />
        </div>
        <div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Homepage;
